import React from "react";

export default function footer() {
  return (
    <div>
      <footer className="revealed">
        <div className="footer_bg">
          <div className="background-image" data-background="url()"></div>
        </div>
        <div className="container">
          <div className="row move_content">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="footerlinks">
                <h5>Get In Touch</h5>
                <ul>
                  <li>
                    Visit us at <br />
                    <strong>No 17, Bandaramulla, Mirissa, Matara</strong> <br />
                    <br />
                  </li>
                  <li>
                    Email us at{" "}
                    <strong>
                      <a
                        className="email"
                        href="mailto:reservations@oryzaleisure.com"
                      >
                        reservations@oryzaleisure.com
                      </a>
                    </strong>
                  </li>
                  <li>
                    Call us :{" "}
                    <strong>
                      <a
                        className="tel"
                        href="tel:+94761407881"
                        style={{ color: "#fff" }}
                      >
                        + 94 76 140 7881
                      </a>
                    </strong>
                  </li>
                </ul>

                <div className="social">
                  <ul>
                    <li>
                      <a
                        href="https://www.facebook.com/pettipettimirissa/"
                        target="_blank"
                         rel="noreferrer"
                      >
                        <i className="bi bi-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/pettipettimirissa/"
                        target="_blank"
                         rel="noreferrer"
                      >
                        <i className="bi bi-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://wa.me/94761407881">
                        <i className="bi bi-whatsapp"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="footerlinks">
                <h5>Navigation</h5>
                <div className="footer_links">
                  <ul>
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href="/dining">Eat & Drink</a>
                    </li>
                    <li>
                      <a href="/events">Events</a>
                    </li>
                    <li>
                      <a href="/offers">Offers</a>
                    </li>
                    <li>
                      <a href="/gallery">Gallery</a>
                    </li>
                    <li>
                      <a href="/about">About Us</a>
                    </li>
                    <li>
                      <a href="/contact">Contact Us</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copy">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-12">
                © 2024 Oryza Leisure. All Rights Reserved.
              </div>
              <div className="col-lg-4 col-12">
                <a href="/terms-and-conditions">Terms and Conditions</a> |{" "}
                <a href="/privacy-policy"> Privacy Policy</a>
              </div>
              <div className="col-lg-4 col-12">
                Designed and Developed by{" "}
                <a href="https://ollcode.com" target="_blank"  rel="noreferrer">
                  <b>Ollcode</b>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
